import { render, staticRenderFns } from "./BookCompanyCard.vue?vue&type=template&id=6f75e7d3&"
import script from "./BookCompanyCard.vue?vue&type=script&lang=ts&"
export * from "./BookCompanyCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports